export const PETS_QUESTION: Record<string, any> = {
  dog: ['Vaccinated', 'Trained', 'Safe & well behaved around other pets'],
  cat: ['Vaccinated', 'Trained', 'Safe & well behaved around other pets'],
};
